import React, { createContext, useContext, useState } from 'react';
import RenameFileSystemNodeDialog from './RenameFileSystemNodeDialog';

const RenameFileSystemNodeDialogContext = createContext();
export const useRenameFileSystemNodeDialog = () => useContext(RenameFileSystemNodeDialogContext);

function RenameFileSystemNodeDialogProvider(props) {
    const { children } = props;

    const [ isRenameFileSystemNodeDialogOpen, setIsRenameFileSystemNodeDialogOpen ] = useState(false);
    const [ fileSystemNodePath, setFileSystemNodePath ] = useState([]);

    const open = (fileSystemNodePath) => {
        setFileSystemNodePath(fileSystemNodePath);
        setIsRenameFileSystemNodeDialogOpen(true);
    }

    return (
        <RenameFileSystemNodeDialogContext.Provider value={{ open }}>
            {children}
            <RenameFileSystemNodeDialog open={isRenameFileSystemNodeDialogOpen} fileSystemNodePath={fileSystemNodePath} handleCancel={() => {setIsRenameFileSystemNodeDialogOpen(false)}}/>
        </RenameFileSystemNodeDialogContext.Provider>
    );
}
export default RenameFileSystemNodeDialogProvider;